<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <template v-if="!takeawayReady">
      <no-product-page />
    </template>
    <div
      v-else
      class="mt-4"
    >
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="black"
        style="background: transparent"
      >
        <v-tab>{{ $t('PickUpAndDeliveryServiceSettings') }}</v-tab>
        <v-tab>{{ $t('DeliveryRange') }}</v-tab>
        <v-tab>{{ $t('DynamicManage') }}</v-tab>
        <v-tab>{{ $t('TakeawayOpeningTime') }}</v-tab>
        <v-tab>{{ $t('TakeawayPickupOpeningTime') }}</v-tab>
        <v-tab>{{ $t('TakeawayVoucherSettingsPickup') }}</v-tab>
        <v-tab>{{ $t('TakeawayAnnouncement') }}</v-tab>
        <v-tab>{{ $t('cloudOrder') }}</v-tab>
        <v-tab>App{{ $t('Order') }}</v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items
        v-model="tab"
        class="mt-4"
        style="background: transparent"
      >
        <v-tab-item>
          <takeaway-web />
        </v-tab-item>
        <v-tab-item>
          <delivery-range-setting />
        </v-tab-item>
        <v-tab-item>
          <activity-post />
        </v-tab-item>
        <v-tab-item>
          <open-time :purpose="'takeaway'" />
        </v-tab-item>
        <v-tab-item>
          <open-time :purpose="'pickup'" />
        </v-tab-item>
        <v-tab-item>
          <takeaway-voucher />
        </v-tab-item>
        <v-tab-item>
          <takeaway-announcement-head />
        </v-tab-item>
        <v-tab-item>
          <takeaway-order-list />
        </v-tab-item>
        <v-tab-item>
          <takeaway-order-by-app />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import TakeawayWeb from '@/views/AadenPages/extraModules/takeaway/TakeawayWeb.vue'
import DeliveryRangeSetting from '@/views/AadenPages/extraModules/takeaway/TakeawaySetting/DeliveryRangeSetting.vue'
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import NoProductPage from '@/views/widget/commonLogic/NoProductPage'
import ActivityPost from '@/views/AadenPages/extraModules/takeaway/components/ActivityPost'
import OpenTime from '@/views/AadenPages/settings/OpenTime.vue'
import TakeawayVoucher from '@/views/AadenPages/extraModules/takeaway/components/TakeawayVoucher'
import TakeawayAnnouncementHead from '@/views/AadenPages/extraModules/takeaway/components/TakeawayAnnouncementHead'
import TakeawayOrderList from '@/views/AadenPages/extraModules/takeaway/TakeawaySetting/TakeawayOrderList'
import TakeawayOrderByApp from '@/views/AadenPages/extraModules/takeaway/TakeawaySetting/TakeawayOrderByApp.vue'

export default {
  name: 'PersonalInfoPage',
  components: {
    TakeawayOrderByApp,
    TakeawayOrderList,
    TakeawayAnnouncementHead,
    TakeawayVoucher,
    OpenTime,
    ActivityPost,
    NoProductPage,
    DeliveryRangeSetting,
    TakeawayWeb
  },
  data () {
    return {
      tab: null,
      takeawayReady: false
    }
  },
  async mounted () {
    try {
      const res = await getActiveProductCode()
      this.takeawayReady = res.includes(ProductCodes.takeawayWeb)
    } catch (e) {
      console.log(e)
    }
  }
}
</script>

<style scoped>
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
</style>
